import axios from 'axios';

const REACT_APP_BFF_URL = process.env.REACT_APP_BFF_URL;

const base64ToBlob = (base64, mime) => {
    const byteString = atob(base64);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], {type: mime});
};

export const createVeterinary = async (
    token,
    name,
    address,
    phone_number,
    logo, // puede ser File o base64 string "data:…;base64,…"
    pdf_report, // idem
  ) => {
    const formData = new FormData()
  
    // campos de texto
    formData.append("name", name)
    formData.append("address", address)
    formData.append("phone_number", phone_number)
  
    // helper: detecta si es base64 string y convierte a Blob, o lo añade directo si es File
    const appendFile = (fieldName, fileOrBase64, defaultFilename, defaultMime) => {
      if (!fileOrBase64) return
      if (typeof fileOrBase64 === "string" && fileOrBase64.includes("base64")) {
        const [meta, data] = fileOrBase64.split(",")
        const mime = meta.match(/:(.*?);/)[1] || defaultMime
        const blob = base64ToBlob(data, mime)
        const ext = mime.split("/")[1] || defaultFilename.split(".").pop()
        formData.append(fieldName, blob, `${fieldName}.${ext}`)
      } else if (fileOrBase64 instanceof File || fileOrBase64 instanceof Blob) {
        // si ya es File/Blob (por ejemplo desde <input type="file" />)
        formData.append(fieldName, fileOrBase64, fileOrBase64.name ?? defaultFilename)
      }
    }
  
    appendFile("logo", logo, "logo.png", "image/png")
    appendFile("pdf_report", pdf_report, "report.pdf", "application/pdf")
  
    // enviamos con axios para manejar multipart/form-data
    const response = await axios.post(`${process.env.REACT_APP_BFF_URL}/veterinaries`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        // IMPORTANTE: con axios multipart el header Content-Type se ajusta solo
        "Content-Type": "multipart/form-data",
      },
    })
  
    return response.data
  }

  

export const getAllVeterinaries = async (token) => {
    const url = new URL(`${REACT_APP_BFF_URL}/veterinaries`);

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Error occurred while fetching veterinaries.');
    }

    const data = await response.json();
    return data.veterinaries;
};

export const getMyVeterinary = async (token) => {
    const response = await fetch(`${REACT_APP_BFF_URL}/veterinaries/me`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Error occurred while fetching your veterinary.');
    }

    return response.json();
};

export const getVeterinaryById = async (token, veterinaryId) => {
    const response = await fetch(`${REACT_APP_BFF_URL}/veterinaries/${veterinaryId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Error occurred while fetching veterinary.');
    }

    return response.json();
};

export const updateVeterinary = async (token, veterinaryId, updateData) => {
    const response = await fetch(`${REACT_APP_BFF_URL}/veterinaries/${veterinaryId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(updateData)
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Error occurred while updating veterinary.');
    }

    return response.json();
};

export const deleteVeterinary = async (token, veterinaryId) => {
    const response = await fetch(`${REACT_APP_BFF_URL}/veterinaries/${veterinaryId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Error occurred while deleting veterinary.');
    }

    return response.json();
};
